<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const avatars = [
	'/images/welcome/avatar-1.jpg',
	'/images/welcome/avatar-2.png',
	'/images/welcome/avatar-3.png',
	'/images/welcome/avatar-4.png',
];
</script>

<template>
	<section class="section-welcome-hero">
		<div class="section-welcome-hero__social-proof">
			<img src="/images/welcome/quote-left.svg" alt="" class="section-welcome-hero__quote" />
			<div class="section-welcome-hero__avatars">
				<img
					v-for="(src, i) in avatars"
					:key="i"
					:src="src"
					alt=""
					class="section-welcome-hero__avatar"
				/>
			</div>
			<p class="section-welcome-hero__proof-text">
				{{ t('welcome.hero.social_proof_prefix') }}
				<span class="section-welcome-hero__proof-count">{{ t('welcome.hero.social_proof_count') }}</span>
			</p>
			<img src="/images/welcome/quote-right.svg" alt="" class="section-welcome-hero__quote" />
		</div>

		<h1 class="section-welcome-hero__title">{{ t('welcome.hero.title') }}</h1>
		<p class="section-welcome-hero__subtitle">{{ t('welcome.hero.subtitle') }}</p>
	</section>
</template>

<style lang="scss">
.section-welcome-hero {
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;
	padding: 4rem 0 0;

	@include min-desktop {
		padding: 6rem 0 0;
	}

	&__social-proof {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0.8rem;
	}

	&__quote {
		width: 2.4rem;
		height: 2.4rem;
		flex-shrink: 0;

		@include theme-dark {
			filter: brightness(0) invert(1);
		}
	}

	&__avatars {
		display: flex;
		align-items: center;
	}

	&__avatar {
		width: 2.8rem;
		height: 2.8rem;
		border-radius: 50%;
		border: 2px solid var(--color-white);
		object-fit: cover;
		flex-shrink: 0;

		& + & {
			margin-left: -0.8rem;
		}

		@include theme-dark {
			border-color: #1a1a2e;
		}
	}

	&__proof-text {
		@include font-regular;
		color: rgba(var(--color-text-rgb), 1);
		letter-spacing: -0.014rem;

		@include min-desktop {
			@include font-18-pro-medium;
			letter-spacing: -0.018rem;
		}
	}

	&__proof-count {
		color: var(--color-purple);
		display: block;

		@include min-desktop {
			display: inline;
		}

		@include theme-dark {
			color: var(--color-active);
		}
	}

	&__title {
		@include font-32-pro-bold;
		line-height: 1;
		letter-spacing: -0.096rem;
		color: rgba(var(--color-text-rgb), 1);
		max-width: 60rem;

		@include min-desktop {
			font-size: 6.4rem;
			letter-spacing: -0.192rem;
		}
	}

	&__subtitle {
		@include font-16-pro-regular;
		color: rgba(var(--color-text-rgb), 1);
		letter-spacing: -0.016rem;
		line-height: 1.1;

		@include min-desktop {
			font-size: 2.4rem;
			letter-spacing: -0.024rem;
		}
	}
}
</style>
